











import { iosCustomUrlSchemes, navigateToHlAppDeeplink } from '@/models/hl-app/custom-url-scheme'
import { HlAppMode } from '@/models/hl-app/hl-app-mode'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class DeliveryTrackingLink extends Vue {
  @Prop({ required: true })
  url: string | undefined

  open() {
    if (!this.url) return

    if (HlAppMode.isViewedInHlAppWebView) {
      navigateToHlAppDeeplink(iosCustomUrlSchemes.createOpenExternalUrl(this.url))
    } else {
      window.open(this.url, '_blank', 'noopener,noreferrer')
    }
  }
}
